import { FC } from 'react'

export type IconName =
  | 'arrow-left'
  | 'arrow-right'
  | 'award'
  | 'bar-chart'
  | 'bell'
  | 'calendar'
  | 'checkmark'
  | 'checkmark-circle'
  | 'checkmark-square'
  | 'chevron-down'
  | 'chevron-left'
  | 'chevron-right'
  | 'chevron-up'
  | 'clock'
  | 'close-circle'
  | 'code'
  | 'copy'
  | 'copy-outlined'
  | 'edit'
  | 'eye'
  | 'eye-off'
  | 'expand'
  | 'file-text'
  | 'flash'
  | 'flask'
  | 'github'
  | 'google'
  | 'height'
  | 'info'
  | 'info-outlined'
  | 'issue-closed'
  | 'issue-linked'
  | 'layers'
  | 'list'
  | 'minus-circle'
  | 'moon'
  | 'more-vertical'
  | 'open-external-link'
  | 'options-2'
  | 'people'
  | 'person'
  | 'pie-chart'
  | 'plus'
  | 'pr-closed'
  | 'pr-draft'
  | 'pr-linked'
  | 'pr-merged'
  | 'radio'
  | 'refresh'
  | 'request'
  | 'rocket'
  | 'features'
  | 'search'
  | 'setting'
  | 'shield'
  | 'link'
  | 'lock'
  | 'sun'
  | 'timer'
  | 'trash-2'
  | 'warning'

type IconType = React.DetailedHTMLProps<
  React.HTMLAttributes<SVGSVGElement>,
  SVGSVGElement
> & {
  name: IconName
  width?: number
  height?: number
  fill?: string
  fill2?: string
  className?: string
}

const Icon: FC<IconType> = ({
  fill,
  fill2: _fill2,
  height,
  name,
  width,
  ...rest
}) => {
  switch (name) {
    case 'code': {
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={width || '24'}
          height={width || '20'}
          viewBox='0 0 24 24'
          fill='none'
          {...rest}
        >
          <g id='Outlined/code'>
            <path
              id='Icon'
              fillRule='evenodd'
              clipRule='evenodd'
              d='M16.9513 5.37306L21.7793 11.3731C22.0783 11.7441 22.0733 12.2741 21.7683 12.6411L16.7683 18.6411C16.5703 18.8781 16.2863 19.0001 15.9993 19.0001C15.7733 19.0001 15.5473 18.9241 15.3593 18.7691C14.9353 18.4151 14.8783 17.7841 15.2313 17.3591L19.7083 11.9891L15.3923 6.62706C15.0473 6.19606 15.1143 5.56706 15.5453 5.22106C15.9753 4.87306 16.6043 4.94306 16.9513 5.37306ZM7.23155 5.35946C7.58455 4.93546 8.21355 4.87846 8.64055 5.23146C9.06455 5.58546 9.12155 6.21546 8.76855 6.64046L4.29155 12.0105L8.60755 17.3735C8.95255 17.8035 8.88555 18.4325 8.45455 18.7795C8.27055 18.9275 8.04855 19.0005 7.82855 19.0005C7.53655 19.0005 7.24655 18.8725 7.04855 18.6275L2.22055 12.6275C1.92155 12.2555 1.92655 11.7255 2.23155 11.3595L7.23155 5.35946Z'
              fill={fill || 'currentColor'}
            />
          </g>
        </svg>
      )
    }
    case 'link': {
      return (
        <svg
          width='16'
          height='16'
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g id='Outlined/external-link'>
            <path
              id='Icon'
              fillRule='evenodd'
              clipRule='evenodd'
              d='M19 18V12C19 11.448 19.447 11 20 11C20.553 11 21 11.448 21 12V18C21 19.654 19.654 21 18 21H6C4.346 21 3 19.654 3 18V6C3 4.346 4.346 3 6 3H12C12.553 3 13 3.448 13 4C13 4.552 12.553 5 12 5H6C5.448 5 5 5.449 5 6V18C5 18.551 5.448 19 6 19H18C18.552 19 19 18.551 19 18ZM17.5781 5.008L15.9951 5C15.4421 4.997 14.9971 4.547 15.0001 3.995C15.0031 3.444 15.4501 3 16.0001 3H16.0051L20.0021 3.02C20.5521 3.023 20.9971 3.469 20.9971 4.019L21.0001 7.999C21.0001 8.552 20.5531 9 20.0011 9H20.0001C19.4481 9 19.0001 8.553 19.0001 8.001L18.9991 6.415L12.7071 12.707C12.5121 12.902 12.2561 13 12.0001 13C11.7441 13 11.4881 12.902 11.2931 12.707C10.9021 12.316 10.9021 11.684 11.2931 11.293L17.5781 5.008Z'
              fill='rgb(104, 55, 252)'
            />
          </g>
        </svg>
      )
    }
    case 'lock': {
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={width || '24'}
          height={height || width || '24'}
          viewBox='0 0 512 512'
          fill='none'
          {...rest}
        >
          <path
            d='M368 192h-16v-80a96 96 0 10-192 0v80h-16a64.07 64.07 0 00-64 64v176a64.07 64.07 0 0064 64h224a64.07 64.07 0 0064-64V256a64.07 64.07 0 00-64-64zm-48 0H192v-80a64 64 0 11128 0z'
            fill={fill || 'currentColor'}
          />
        </svg>
      )
    }
    case 'shield': {
      return (
        <svg
          width={width || '24'}
          height={height || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g id='Outlined/shield'>
            <path
              id='Icon'
              fillRule='evenodd'
              clipRule='evenodd'
              d='M12 4.14649L5 8.08449V8.22949C5 12.9695 7.566 17.3585 11.698 19.6835L12 19.8535L12.302 19.6835C16.434 17.3585 19 12.9695 19 8.22949V8.08449L12 4.14649ZM12 21.8505C11.661 21.8505 11.322 21.7665 11.021 21.5965L10.718 21.4255C5.957 18.7485 3 13.6915 3 8.22949V8.08449C3 7.36549 3.39 6.69749 4.018 6.34249L11.02 2.40449C11.625 2.06449 12.376 2.06349 12.979 2.40349L19.98 6.34149C20.61 6.69749 21 7.36549 21 8.08449V8.22949C21 13.6915 18.043 18.7485 13.282 21.4255L12.98 21.5955C12.678 21.7655 12.339 21.8505 12 21.8505Z'
              fill={fill || 'currentColor'}
            />
          </g>
        </svg>
      )
    }
    case 'plus': {
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={width || '21'}
          height={width || '20'}
          viewBox='0 0 21 20'
          fill='none'
          {...rest}
        >
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M16.4429 9.16658H11.4429V4.16659C11.4429 3.70575 11.0695 3.33325 10.6095 3.33325C10.1495 3.33325 9.7762 3.70575 9.7762 4.16659V9.16658H4.7762C4.3162 9.16658 3.94287 9.53909 3.94287 9.99992C3.94287 10.4608 4.3162 10.8333 4.7762 10.8333H9.7762V15.8333C9.7762 16.2941 10.1495 16.6666 10.6095 16.6666C11.0695 16.6666 11.4429 16.2941 11.4429 15.8333V10.8333H16.4429C16.9029 10.8333 17.2762 10.4608 17.2762 9.99992C17.2762 9.53909 16.9029 9.16658 16.4429 9.16658Z'
            fill={fill || 'currentColor'}
          />
        </svg>
      )
    }
    case 'eye': {
      return (
        <svg
          width={width || '22'}
          height={width || '22'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            id='Icon'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M12 13.5C11.173 13.5 10.5 12.827 10.5 12C10.5 11.173 11.173 10.5 12 10.5C12.827 10.5 13.5 11.173 13.5 12C13.5 12.827 12.827 13.5 12 13.5ZM12 8.50002C10.0701 8.50002 8.50005 10.07 8.50005 12C8.50005 13.93 10.0701 15.5 12 15.5C13.93 15.5 15.5 13.93 15.5 12C15.5 10.07 13.93 8.50002 12 8.50002ZM12.2197 16.9976C7.91375 17.0976 5.10475 13.4146 4.17275 11.9956C5.19875 10.3906 7.78275 7.10462 11.7808 7.00262C16.0697 6.89362 18.8948 10.5856 19.8267 12.0046C18.8018 13.6096 16.2167 16.8956 12.2197 16.9976ZM21.8678 11.5026C21.2297 10.3906 17.7057 4.81662 11.7297 5.00362C6.20175 5.14362 2.98675 10.0136 2.13275 11.5026C1.95575 11.8106 1.95575 12.1896 2.13275 12.4976C2.76175 13.5946 6.16175 18.9996 12.0247 18.9996C12.1067 18.9996 12.1888 18.9986 12.2708 18.9966C17.7978 18.8556 21.0138 13.9866 21.8678 12.4976C22.0438 12.1896 22.0438 11.8106 21.8678 11.5026Z'
            fill={fill || 'currentColor'}
          />
        </svg>
      )
    }
    case 'eye-off': {
      return (
        <svg
          width={width || '22'}
          height={width || '22'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            id='Icon'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M12 13.5C11.173 13.5 10.5 12.827 10.5 12C10.5 11.9869 10.5031 11.9741 10.5061 11.9613L10.5061 11.9613C10.5088 11.9496 10.5116 11.9379 10.512 11.926L12.074 13.488C12.0621 13.4885 12.0504 13.4912 12.0388 13.494C12.0259 13.497 12.0131 13.5 12 13.5ZM4.70705 3.29301C4.31605 2.90201 3.68405 2.90201 3.29305 3.29301C2.90205 3.68401 2.90205 4.31601 3.29305 4.70701L8.92305 10.337C8.64705 10.846 8.50005 11.411 8.50005 12C8.50005 13.93 10.0701 15.5 12 15.5C12.589 15.5 13.154 15.353 13.663 15.077L19.293 20.707C19.488 20.902 19.744 21 20 21C20.2561 21 20.5121 20.902 20.7071 20.707C21.0981 20.316 21.0981 19.684 20.7071 19.293L4.70705 3.29301ZM12.2198 16.9976C7.91475 17.0976 5.10475 13.4146 4.17275 11.9956C4.62975 11.2816 5.39575 10.2356 6.45575 9.28461L5.04475 7.87261C3.52275 9.26161 2.54675 10.7796 2.13275 11.5026C1.95575 11.8106 1.95575 12.1896 2.13275 12.4976C2.76175 13.5946 6.16175 18.9996 12.0247 18.9996C12.1067 18.9996 12.1888 18.9986 12.2708 18.9966C13.4548 18.9666 14.5268 18.7106 15.4978 18.3266L13.9178 16.7466C13.3828 16.8886 12.8198 16.9826 12.2198 16.9976ZM11.7297 5.00341C17.7048 4.81641 21.2298 10.3904 21.8678 11.5024C22.0438 11.8104 22.0438 12.1894 21.8678 12.4974C21.4528 13.2204 20.4767 14.7384 18.9548 16.1274L17.5437 14.7154C18.6037 13.7644 19.3708 12.7184 19.8267 12.0044C18.8947 10.5854 16.0717 6.89441 11.7808 7.00241C11.1807 7.01741 10.6178 7.11141 10.0817 7.25341L8.50175 5.67341C9.47375 5.28941 10.5448 5.03341 11.7297 5.00341Z'
            fill={fill || 'currentColor'}
          />
        </svg>
      )
    }
    case 'github': {
      return (
        <svg
          width={width || '20'}
          height={height || '20'}
          viewBox='0 0 20 20'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          {...rest}
        >
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M10.4987 0.833984C5.43703 0.833984 1.33203 4.85065 1.33203 9.80648C1.33203 13.769 3.9587 17.1323 7.6012 18.3182C8.06036 18.4007 8.22703 18.124 8.22703 17.8857C8.22703 17.6732 8.21953 17.1082 8.21536 16.3607C5.66537 16.9023 5.12786 15.1573 5.12786 15.1573C4.71036 14.1207 4.10953 13.8448 4.10953 13.8448C3.27703 13.2882 4.17286 13.2998 4.17286 13.2998C5.09286 13.3632 5.5762 14.224 5.5762 14.224C6.3937 15.5957 7.7212 15.199 8.24453 14.9698C8.32787 14.3906 8.5637 13.9948 8.8262 13.7698C6.79036 13.544 4.65036 12.774 4.65036 9.33648C4.65036 8.35732 5.00786 7.55648 5.59453 6.92898C5.49953 6.70232 5.18536 5.78982 5.6837 4.55482C5.6837 4.55482 6.4537 4.31398 8.20537 5.47398C8.9362 5.27482 9.72037 5.17648 10.4995 5.17232C11.2779 5.17648 12.062 5.27482 12.7945 5.47398C14.5445 4.31398 15.3129 4.55482 15.3129 4.55482C15.8129 5.78982 15.4987 6.70232 15.4037 6.92898C15.9912 7.55648 16.3462 8.35732 16.3462 9.33648C16.3462 12.7832 14.2029 13.5415 12.1612 13.764C12.4904 14.0407 12.7829 14.5882 12.7829 15.4248C12.7829 16.624 12.772 17.5915 12.772 17.8857C12.772 18.1257 12.937 18.4048 13.402 18.3173C17.0412 17.129 19.6654 13.7682 19.6654 9.80648C19.6654 4.85065 15.5612 0.833984 10.4987 0.833984Z'
            fill={fill || 'currentColor'}
          />
        </svg>
      )
    }
    case 'google': {
      return (
        <svg
          width='21'
          height='20'
          viewBox='0 0 21 20'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          {...rest}
        >
          <g clipPath='url(#clip0_2294_2557)'>
            <g clipPath='url(#clip1_2294_2557)'>
              <path
                d='M20.1047 10.2292C20.1047 9.54941 20.0496 8.86599 19.932 8.19727H10.5V12.048H15.9012C15.6771 13.2899 14.9569 14.3885 13.9024 15.0866V17.5851H17.1248C19.0171 15.8435 20.1047 13.2715 20.1047 10.2292Z'
                fill='#4285F4'
              />
              <path
                d='M10.5004 19.9995C13.1973 19.9995 15.4717 19.114 17.1289 17.5855L13.9065 15.087C13.01 15.6969 11.8525 16.0423 10.5041 16.0423C7.8953 16.0423 5.68336 14.2823 4.88971 11.916H1.56445V14.4917C3.26199 17.8684 6.71952 19.9995 10.5004 19.9995Z'
                fill='#34A853'
              />
              <path
                d='M4.8853 11.9161C4.46643 10.6741 4.46643 9.32934 4.8853 8.08742V5.51172H1.56371C0.145428 8.33727 0.145428 11.6662 1.56371 14.4918L4.8853 11.9161Z'
                fill='#FBBC04'
              />
              <path
                d='M10.5004 3.95791C11.926 3.93587 13.3039 4.47232 14.3364 5.45704L17.1913 2.60209C15.3836 0.904556 12.9842 -0.0287207 10.5004 0.000673865C6.71952 0.000673865 3.26199 2.13178 1.56445 5.51215L4.88604 8.08785C5.67601 5.71791 7.89163 3.95791 10.5004 3.95791Z'
                fill='#EA4335'
              />
            </g>
          </g>
          <defs>
            <clipPath id='clip0_2294_2557'>
              <rect
                width='20'
                height='20'
                fill='white'
                transform='translate(0.5)'
              />
            </clipPath>
            <clipPath id='clip1_2294_2557'>
              <rect
                width='19.6043'
                height='20'
                fill='white'
                transform='translate(0.5)'
              />
            </clipPath>
          </defs>
        </svg>
      )
    }
    case 'search': {
      return (
        <svg
          width={width || '22'}
          height={width || '22'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            id='Icon'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M5 11C5 7.691 7.691 5 11 5C14.309 5 17 7.691 17 11C17 14.309 14.309 17 11 17C7.691 17 5 14.309 5 11ZM20.707 19.293L17.312 15.897C18.365 14.543 19 12.846 19 11C19 6.589 15.411 3 11 3C6.589 3 3 6.589 3 11C3 15.411 6.589 19 11 19C12.846 19 14.543 18.365 15.897 17.312L19.293 20.707C19.488 20.902 19.744 21 20 21C20.256 21 20.512 20.902 20.707 20.707C21.098 20.316 21.098 19.684 20.707 19.293Z'
            fill={fill || 'currentColor'}
          />
        </svg>
      )
    }
    case 'sun': {
      return (
        <svg
          width={width || '16'}
          height={width || '16'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            id='Icon'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M12 6C12.552 6 13 5.553 13 5V3C13 2.447 12.552 2 12 2C11.448 2 11 2.447 11 3V5C11 5.553 11.448 6 12 6ZM21 11H19C18.448 11 18 11.447 18 12C18 12.553 18.448 13 19 13H21C21.552 13 22 12.553 22 12C22 11.447 21.552 11 21 11ZM5 11C5.552 11 6 11.447 6 12C6 12.553 5.552 13 5 13H3C2.448 13 2 12.553 2 12C2 11.447 2.448 11 3 11H5ZM6.2207 5.0283C5.8237 4.6453 5.1907 4.6573 4.8067 5.0533C4.4227 5.4503 4.4337 6.0843 4.8307 6.4673L6.2697 7.8573C6.4647 8.0453 6.7147 8.1373 6.9647 8.1373C7.2267 8.1373 7.4877 8.0353 7.6837 7.8323C8.0677 7.4353 8.0567 6.8013 7.6597 6.4183L6.2207 5.0283ZM17.7302 7.8577C17.5352 8.0447 17.2852 8.1377 17.0352 8.1377C16.7732 8.1377 16.5122 8.0347 16.3162 7.8317C15.9322 7.4357 15.9432 6.8017 16.3402 6.4177L17.7792 5.0287C18.1782 4.6457 18.8102 4.6577 19.1932 5.0537C19.5772 5.4497 19.5662 6.0837 19.1692 6.4677L17.7302 7.8577ZM12 18C11.448 18 11 18.447 11 19V21C11 21.553 11.448 22 12 22C12.552 22 13 21.553 13 21V19C13 18.447 12.552 18 12 18ZM16.316 16.1676C16.7 15.7716 17.333 15.7596 17.73 16.1426L19.169 17.5326C19.566 17.9156 19.577 18.5496 19.193 18.9466C18.997 19.1496 18.736 19.2516 18.474 19.2516C18.224 19.2516 17.974 19.1596 17.779 18.9716L16.34 17.5816C15.943 17.1986 15.932 16.5646 16.316 16.1676ZM6.27 16.1426L4.831 17.5326C4.434 17.9156 4.423 18.5496 4.807 18.9466C5.003 19.1496 5.264 19.2516 5.526 19.2516C5.776 19.2516 6.026 19.1596 6.221 18.9716L7.66 17.5816C8.057 17.1986 8.068 16.5646 7.684 16.1676C7.301 15.7716 6.668 15.7596 6.27 16.1426ZM8 12C8 9.794 9.794 8 12 8C14.206 8 16 9.794 16 12C16 14.206 14.206 16 12 16C9.794 16 8 14.206 8 12Z'
            fill={fill || 'currentColor'}
          />
        </svg>
      )
    }
    case 'moon': {
      return (
        <svg
          width={width || '16'}
          height={width || '16'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            id='Icon'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M12.2959 22C12.2639 22 12.2329 22 12.1999 21.999C9.40592 21.975 6.79792 20.854 4.85592 18.846C1.17892 15.041 1.06392 8.74401 4.59892 4.80901C5.69992 3.58201 7.04392 2.65901 8.59192 2.06601C8.95692 1.92401 9.37192 2.01201 9.65092 2.28801C9.93092 2.56301 10.0239 2.97601 9.88892 3.34401C8.77092 6.39901 9.53192 9.85501 11.8299 12.148C14.1269 14.441 17.5929 15.202 20.6579 14.086C21.0259 13.95 21.4389 14.046 21.7129 14.324C21.9879 14.604 22.0739 15.019 21.9339 15.384C21.4099 16.747 20.6239 17.957 19.5979 18.98C17.6449 20.93 15.0539 22 12.2959 22Z'
            fill={fill || 'currentColor'}
          />
        </svg>
      )
    }
    case 'checkmark-square': {
      return (
        <svg
          width='20'
          height='20'
          viewBox='3 3 18 18'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            id='Icon'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M16.2954 9.60549L11.7274 15.6055C11.5394 15.8525 11.2484 15.9985 10.9384 16.0005H10.9314C10.6244 16.0005 10.3344 15.8585 10.1444 15.6165L7.71243 12.5095C7.37243 12.0755 7.44843 11.4465 7.88343 11.1065C8.31843 10.7655 8.94643 10.8415 9.28743 11.2775L10.9204 13.3635L14.7044 8.39449C15.0384 7.95549 15.6664 7.86949 16.1064 8.20449C16.5454 8.53949 16.6304 9.16649 16.2954 9.60549ZM18.0004 3.00049H6.00043C4.34543 3.00049 3.00043 4.34549 3.00043 6.00049V18.0005C3.00043 19.6545 4.34543 21.0005 6.00043 21.0005H18.0004C19.6544 21.0005 21.0004 19.6545 21.0004 18.0005V6.00049C21.0004 4.34549 19.6544 3.00049 18.0004 3.00049Z'
            fill={fill || '#6837FC'}
          />
        </svg>
      )
    }
    case 'checkmark': {
      return (
        <svg
          width={width || '24'}
          height={width || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          {...rest}
        >
          <path
            id='Icon'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M9.86326 18C9.58726 18 9.32326 17.886 9.13426 17.685L4.27126 12.506C3.89226 12.104 3.91326 11.471 4.31526 11.093C4.71826 10.715 5.35126 10.735 5.72826 11.137L9.85326 15.528L18.2613 6.32599C18.6353 5.91699 19.2673 5.88999 19.6753 6.26199C20.0823 6.63399 20.1103 7.26699 19.7383 7.67399L10.6013 17.674C10.4143 17.88 10.1483 17.998 9.87026 18H9.86326Z'
            fill={fill || 'currentColor'}
          />
        </svg>
      )
    }
    case 'info': {
      return (
        <svg
          width={width || '28'}
          height={width || '28'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            id='Icon'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M12 9C11.448 9 11 8.552 11 8C11 7.448 11.448 7 12 7C12.552 7 13 7.448 13 8C13 8.552 12.552 9 12 9ZM13 16C13 16.552 12.552 17 12 17C11.448 17 11 16.552 11 16V11C11 10.448 11.448 10 12 10C12.552 10 13 10.448 13 11V16ZM12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22C17.522 22 22 17.523 22 12C22 6.477 17.522 2 12 2Z'
            fill={fill || '#0AADDF'}
          />
        </svg>
      )
    }
    case 'info-outlined': {
      return (
        <svg
          width={width || '20'}
          height={width || '20'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            id='Icon'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M11 8C11 7.448 11.448 7 12 7C12.552 7 13 7.448 13 8C13 8.552 12.552 9 12 9C11.448 9 11 8.552 11 8ZM11 11C11 10.448 11.448 10 12 10C12.552 10 13 10.448 13 11V16C13 16.552 12.552 17 12 17C11.448 17 11 16.552 11 16V11ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20ZM12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22C17.522 22 22 17.523 22 12C22 6.477 17.522 2 12 2Z'
            fill={fill || 'currentColor'}
          />
        </svg>
      )
    }
    case 'close-circle': {
      return (
        <svg
          width={width || '28'}
          height={width || '28'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            id='Icon'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M14.707 13.2929C15.098 13.6839 15.098 14.3159 14.707 14.7069C14.512 14.9019 14.256 14.9999 14 14.9999C13.744 14.9999 13.488 14.9019 13.293 14.7069L12 13.4139L10.707 14.7069C10.512 14.9019 10.256 14.9999 10 14.9999C9.744 14.9999 9.488 14.9019 9.293 14.7069C8.902 14.3159 8.902 13.6839 9.293 13.2929L10.586 11.9999L9.293 10.7069C8.902 10.3159 8.902 9.68388 9.293 9.29288C9.684 8.90188 10.316 8.90188 10.707 9.29288L12 10.5859L13.293 9.29288C13.684 8.90188 14.316 8.90188 14.707 9.29288C15.098 9.68388 15.098 10.3159 14.707 10.7069L13.414 11.9999L14.707 13.2929ZM12 1.99988C6.486 1.99988 2 6.48588 2 11.9999C2 17.5139 6.486 21.9999 12 21.9999C17.514 21.9999 22 17.5139 22 11.9999C22 6.48588 17.514 1.99988 12 1.99988Z'
            fill={fill || '#EF4D56'}
          />
        </svg>
      )
    }
    case 'chevron-down': {
      return (
        <svg
          width={width || '24'}
          height={width || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          {...rest}
        >
          <path
            id='Icon'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M12 15.5C11.744 15.5 11.488 15.402 11.293 15.207L7.29301 11.207C6.90201 10.816 6.90201 10.184 7.29301 9.79301C7.68401 9.40201 8.31601 9.40201 8.70701 9.79301L12.012 13.098L15.305 9.91801C15.704 9.53501 16.335 9.54601 16.719 9.94301C17.103 10.34 17.092 10.974 16.695 11.357L12.695 15.219C12.5 15.407 12.25 15.5 12 15.5Z'
            fill={fill || 'currentColor'}
          />
        </svg>
      )
    }
    case 'chevron-right': {
      return (
        <svg
          width={width || '24'}
          height={width || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            id='Icon'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M10.5 17C10.244 17 9.98801 16.902 9.79301 16.707C9.40201 16.316 9.40201 15.684 9.79301 15.293L13.098 11.988L9.91801 8.695C9.53501 8.297 9.54601 7.664 9.94301 7.281C10.341 6.898 10.974 6.909 11.357 7.305L15.219 11.305C15.598 11.698 15.593 12.321 15.207 12.707L11.207 16.707C11.012 16.902 10.756 17 10.5 17Z'
            fill={fill || 'currentColor'}
          />
        </svg>
      )
    }
    case 'chevron-left': {
      return (
        <svg
          width={width || '24'}
          height={width || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            id='Icon'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M13.3623 17C13.1003 17 12.8393 16.898 12.6433 16.695L8.78028 12.695C8.40228 12.302 8.40728 11.679 8.79328 11.293L12.7933 7.29301C13.1833 6.90201 13.8163 6.90201 14.2073 7.29301C14.5973 7.68401 14.5973 8.31601 14.2073 8.70701L10.9023 12.012L14.0813 15.305C14.4653 15.703 14.4543 16.336 14.0573 16.719C13.8623 16.907 13.6123 17 13.3623 17Z'
            fill={fill || 'currentColor'}
          />
        </svg>
      )
    }
    case 'arrow-left': {
      return (
        <svg
          width={width || '24'}
          height={width || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            id='Icon'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M19 11H7.135L10.768 6.64003C11.122 6.21603 11.064 5.58503 10.64 5.23203C10.215 4.87803 9.585 4.93603 9.232 5.36003L4.232 11.36C4.193 11.407 4.173 11.462 4.144 11.514C4.12 11.556 4.091 11.592 4.073 11.638C4.028 11.753 4.001 11.874 4.001 11.996C4.001 11.997 4 11.999 4 12C4 12.001 4.001 12.003 4.001 12.004C4.001 12.126 4.028 12.247 4.073 12.362C4.091 12.408 4.12 12.444 4.144 12.486C4.173 12.538 4.193 12.593 4.232 12.64L9.232 18.64C9.43 18.877 9.714 19 10 19C10.226 19 10.453 18.924 10.64 18.768C11.064 18.415 11.122 17.784 10.768 17.36L7.135 13H19C19.552 13 20 12.552 20 12C20 11.448 19.552 11 19 11Z'
            fill={fill || 'currentColor'}
          />
        </svg>
      )
    }
    case 'file-text': {
      return (
        <svg
          width={width || '24'}
          height={width || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          {...rest}
        >
          <path
            id='Icon'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M14.7139 8C14.3199 8 13.9999 7.619 13.9999 7.15V3.978L17.7419 8H14.7139ZM14.9999 18H8.99988C8.44788 18 7.99988 17.552 7.99988 17C7.99988 16.448 8.44788 16 8.99988 16H14.9999C15.5529 16 15.9999 16.448 15.9999 17C15.9999 17.552 15.5529 18 14.9999 18ZM8.99988 12H11.9999C12.5519 12 12.9999 12.448 12.9999 13C12.9999 13.552 12.5519 14 11.9999 14H8.99988C8.44788 14 7.99988 13.552 7.99988 13C7.99988 12.448 8.44788 12 8.99988 12ZM19.7399 7.328L15.2959 2.328C15.1069 2.119 14.8379 2 14.5559 2H6.55588C5.14688 2 3.99988 3.122 3.99988 4.5V19.5C3.99988 20.878 5.14688 22 6.55588 22H17.4439C18.8539 22 19.9999 20.878 19.9999 19.5V8C19.9999 7.751 19.9069 7.512 19.7399 7.328Z'
            fill={fill || 'currentColor'}
          />
        </svg>
      )
    }
    case 'copy': {
      return (
        <svg
          width={width || '16'}
          height={width || '16'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            id='Icon'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M9 12V13H5.667C5.299 13 5 12.701 5 12.333V5.667C5 5.299 5.299 5 5.667 5H12.333C12.701 5 13 5.299 13 5.667V9H12C10.346 9 9 10.346 9 12ZM18 9H15V5.667C15 4.196 13.804 3 12.333 3H5.667C4.196 3 3 4.196 3 5.667V12.333C3 13.804 4.196 15 5.667 15H9V18C9 19.654 10.346 21 12 21H18C19.654 21 21 19.654 21 18V12C21 10.346 19.654 9 18 9Z'
            fill={fill || 'currentColor'}
          />
        </svg>
      )
    }
    case 'copy-outlined': {
      return (
        <svg
          width={width || '16'}
          height={width || '16'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            id='Icon'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M9 13V12C9 10.346 10.346 9 12 9H13V5.667C13 5.299 12.701 5 12.333 5H5.667C5.299 5 5 5.299 5 5.667V12.333C5 12.701 5.299 13 5.667 13H9ZM9 15H5.667C4.196 15 3 13.804 3 12.333V5.667C3 4.196 4.196 3 5.667 3H12.333C13.804 3 15 4.196 15 5.667V9H18C19.654 9 21 10.346 21 12V18C21 19.654 19.654 21 18 21H12C10.346 21 9 19.654 9 18V15ZM11 12C11 11.449 11.449 11 12 11H18C18.552 11 19 11.449 19 12V18C19 18.551 18.552 19 18 19H12C11.449 19 11 18.551 11 18V12Z'
            fill={fill || 'currentColor'}
          />
        </svg>
      )
    }
    case 'trash-2': {
      return (
        <svg
          width={width || '24'}
          height={width || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            id='Icon'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M16 16C16 16.55 15.55 17 15 17C14.45 17 14 16.55 14 16V12C14 11.45 14.45 11 15 11C15.55 11 16 11.45 16 12V16ZM10 4.328C10 4.173 10.214 4 10.5 4H13.5C13.786 4 14 4.173 14 4.328V6H10V4.328ZM10 16C10 16.55 9.55 17 9 17C8.45 17 8 16.55 8 16V12C8 11.45 8.45 11 9 11C9.55 11 10 11.45 10 12V16ZM21 6H20H16V4.328C16 3.044 14.879 2 13.5 2H10.5C9.121 2 8 3.044 8 4.328V6H4H3C2.45 6 2 6.45 2 7C2 7.55 2.45 8 3 8H4V19C4 20.654 5.346 22 7 22H17C18.654 22 20 20.654 20 19V8H21C21.55 8 22 7.55 22 7C22 6.45 21.55 6 21 6Z'
            fill={fill || 'currentColor'}
          />
        </svg>
      )
    }
    case 'setting': {
      return (
        <svg
          width={width || '24'}
          height={width || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            id='Icon'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M12 15.5C10.07 15.5 8.5 13.93 8.5 12C8.5 10.07 10.07 8.5 12 8.5C13.93 8.5 15.5 10.07 15.5 12C15.5 13.93 13.93 15.5 12 15.5ZM20.317 9.375H19.233C19.086 9.375 18.986 9.258 18.925 9.111C18.879 9 18.867 8.846 18.972 8.741L19.742 7.975C20.06 7.658 20.236 7.235 20.236 6.787C20.236 6.337 20.062 5.915 19.744 5.598L18.403 4.257C17.749 3.601 16.682 3.603 16.026 4.257L15.256 5.028C15.152 5.133 14.998 5.12 14.853 5.06C14.743 5.015 14.625 4.914 14.625 4.767V3.676C14.625 2.752 13.874 2 12.949 2H11.057C10.129 2 9.375 2.755 9.375 3.683V4.767C9.375 4.914 9.258 5.014 9.111 5.075C9 5.122 8.845 5.134 8.741 5.028L7.976 4.259C7.658 3.94 7.236 3.765 6.787 3.765H6.785C6.336 3.765 5.914 3.939 5.597 4.257L4.257 5.597C3.602 6.251 3.602 7.317 4.257 7.974L5.028 8.744C5.132 8.848 5.12 9.003 5.06 9.147C5.015 9.257 4.914 9.375 4.767 9.375H3.676C2.752 9.375 2 10.126 2 11.051V12.943C2 13.871 2.755 14.625 3.683 14.625H4.767C4.914 14.625 5.014 14.742 5.075 14.889C5.121 15 5.133 15.154 5.028 15.259L4.259 16.024C3.94 16.342 3.765 16.764 3.765 17.213C3.764 17.663 3.939 18.085 4.257 18.403L5.597 19.743C6.251 20.399 7.318 20.397 7.974 19.743L8.744 18.972C8.849 18.869 9.003 18.881 9.147 18.94C9.257 18.985 9.375 19.086 9.375 19.233V20.324C9.375 21.248 10.126 22 11.051 22H12.943C13.871 22 14.625 21.245 14.625 20.317V19.233C14.625 19.086 14.742 18.986 14.889 18.925C14.999 18.879 15.154 18.867 15.259 18.972L16.024 19.741C16.342 20.06 16.764 20.235 17.213 20.235H17.215C17.664 20.235 18.086 20.061 18.403 19.743L19.743 18.403C20.398 17.749 20.398 16.683 19.743 16.026L18.972 15.256C18.868 15.152 18.88 14.997 18.927 14.886C18.927 14.884 18.94 14.854 18.94 14.853C18.985 14.743 19.086 14.625 19.233 14.625H20.324C21.248 14.625 22 13.874 22 12.949V11.057C22 10.129 21.245 9.375 20.317 9.375Z'
            fill={fill || 'currentColor'}
          />
        </svg>
      )
    }
    case 'calendar': {
      return (
        <svg
          width={width || '24'}
          height={width || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            id='Icon'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M19 11H5V7C5 6.449 5.449 6 6 6H7V7C7 7.55 7.45 8 8 8C8.55 8 9 7.55 9 7V6H15V7C15 7.55 15.45 8 16 8C16.55 8 17 7.55 17 7V6H18C18.551 6 19 6.449 19 7V11ZM16 17H12C11.45 17 11 16.55 11 16C11 15.45 11.45 15 12 15H16C16.55 15 17 15.45 17 16C17 16.55 16.55 17 16 17ZM8 17C7.45 17 7 16.55 7 16C7 15.45 7.45 15 8 15C8.55 15 9 15.45 9 16C9 16.55 8.55 17 8 17ZM18 4H17V3C17 2.45 16.55 2 16 2C15.45 2 15 2.45 15 3V4H9V3C9 2.45 8.55 2 8 2C7.45 2 7 2.45 7 3V4H6C4.346 4 3 5.346 3 7V19C3 20.654 4.346 22 6 22H18C19.654 22 21 20.654 21 19V7C21 5.346 19.654 4 18 4Z'
            fill={fill || 'currentColor'}
          />
        </svg>
      )
    }
    case 'edit': {
      return (
        <svg
          width={width || '24'}
          height={width || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g id='Filled/edit'>
            <path
              id='Icon'
              fillRule='evenodd'
              clipRule='evenodd'
              d='M16.0187 10.6787L13.3237 7.98367L15.2717 6.03467L17.9657 8.72867L16.0187 10.6787ZM19.4037 7.33767L19.4027 7.33667L16.6647 4.59867C15.9237 3.85967 14.6507 3.82467 13.9487 4.52967L4.95265 13.5257C4.62665 13.8507 4.42465 14.2827 4.38265 14.7397L4.00365 18.9097C3.97765 19.2047 4.08265 19.4967 4.29265 19.7067C4.48165 19.8957 4.73665 19.9997 4.99965 19.9997C5.03065 19.9997 5.06065 19.9987 5.09065 19.9957L9.26065 19.6167C9.71865 19.5747 10.1497 19.3737 10.4747 19.0487L19.4717 10.0517C20.1997 9.32167 20.1687 8.10367 19.4037 7.33767Z'
              fill={fill || 'currentColor'}
            />
          </g>
        </svg>
      )
    }
    case 'clock': {
      return (
        <svg
          width={width || '24'}
          height={width || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            id='Icon'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M16 11H13V8C13 7.447 12.552 7 12 7C11.448 7 11 7.447 11 8V12C11 12.553 11.448 13 12 13H16C16.553 13 17 12.553 17 12C17 11.447 16.553 11 16 11ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20ZM12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2Z'
            fill={fill || 'currentColor'}
          />
        </svg>
      )
    }
    case 'person': {
      return (
        <svg
          width={width || '24'}
          height={width || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            id='Icon'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M16 7C16 9.206 14.206 11 12 11C9.794 11 8 9.206 8 7C8 4.794 9.794 3 12 3C14.206 3 16 4.794 16 7ZM19 20C19 20.552 18.553 21 18 21H6C5.447 21 5 20.552 5 20C5 16.14 8.141 13 12 13C15.859 13 19 16.14 19 20Z'
            fill={fill || 'currentColor'}
          />
        </svg>
      )
    }
    case 'refresh': {
      return (
        <svg
          width={width || '24'}
          height={width || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            id='Icon'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M20.3032 13.4258C19.7772 13.2588 19.2152 13.5498 19.0472 14.0758C18.1102 17.0218 15.3522 18.9998 12.1842 18.9998C8.22224 18.9998 5.00024 15.8598 5.00024 11.9998C5.00024 8.14082 8.22224 4.99982 12.1842 4.99982C13.9122 4.99982 15.5422 5.60182 16.8292 6.66982L14.6632 6.31282C14.1132 6.21282 13.6032 6.59182 13.5132 7.13582C13.4232 7.68082 13.7922 8.19582 14.3372 8.28482L18.5832 8.98682C18.6382 8.99582 18.6942 8.99982 18.7472 8.99982C18.8662 8.99982 18.9822 8.97882 19.0902 8.93882C19.1272 8.92482 19.1572 8.89882 19.1932 8.87982C19.2592 8.84582 19.3282 8.81582 19.3852 8.76782C19.4212 8.73882 19.4442 8.69682 19.4752 8.66282C19.5222 8.61382 19.5722 8.56682 19.6072 8.50682C19.6322 8.46382 19.6422 8.41282 19.6612 8.36482C19.6852 8.30582 19.7172 8.25082 19.7292 8.18582L20.4832 4.18582C20.5852 3.64282 20.2282 3.11882 19.6852 3.01782C19.1442 2.91982 18.6192 3.27282 18.5172 3.81482L18.2452 5.25582C16.5812 3.81482 14.4482 2.99982 12.1842 2.99982C7.12024 2.99982 3.00024 7.03682 3.00024 11.9998C3.00024 16.9628 7.12024 20.9998 12.1842 20.9998C16.2262 20.9998 19.7502 18.4608 20.9532 14.6818C21.1202 14.1558 20.8292 13.5938 20.3032 13.4258Z'
            fill={fill || 'currentColor'}
          />
        </svg>
      )
    }
    case 'warning': {
      return (
        <svg
          width={width || '28'}
          height={width || '28'}
          viewBox='0 0 26 23'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            id='Icon'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M14.1667 13.1667C14.1667 13.8107 13.644 14.3333 13 14.3333C12.356 14.3333 11.8334 13.8107 11.8334 13.1667V8.50001C11.8334 7.85601 12.356 7.33334 13 7.33334C13.644 7.33334 14.1667 7.85601 14.1667 8.50001V13.1667ZM13 17.8333C12.356 17.8333 11.8334 17.3107 11.8334 16.6667C11.8334 16.0227 12.356 15.5 13 15.5C13.644 15.5 14.1667 16.0227 14.1667 16.6667C14.1667 17.3107 13.644 17.8333 13 17.8333ZM25.3212 17.0202L16.3705 2.18134C15.6717 1.02401 14.4117 0.333344 13 0.333344C11.5884 0.333344 10.3284 1.02401 9.62953 2.18134L0.67886 17.0202C0.0161932 18.1203 -0.00364009 19.4433 0.62636 20.5587C1.30186 21.7568 2.61436 22.5 4.04936 22.5H21.9507C23.3857 22.5 24.6982 21.7568 25.3737 20.5587C26.0037 19.4433 25.9839 18.1203 25.3212 17.0202Z'
            fill={fill || '#FF9F43'}
          />
        </svg>
      )
    }
    case 'bell': {
      return (
        <svg
          width={width || '24'}
          height={width || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g id='Filled/bell'>
            <path
              id='Icon'
              fillRule='evenodd'
              clipRule='evenodd'
              d='M14 18.3413C14 19.2403 13.084 20.0003 12 20.0003C10.916 20.0003 9.99997 19.2403 9.99997 18.3413V18.0003H14V18.3413ZM20.521 15.2073L18.72 13.4043V8.93626C18.72 5.45526 16.218 2.49926 12.899 2.05926C10.978 1.80426 9.03797 2.39026 7.58297 3.66626C6.11897 4.94826 5.27997 6.79326 5.27997 8.72726L5.27897 13.4043L3.47897 15.2083C3.00997 15.6773 2.87097 16.3773 3.12497 16.9903C3.37997 17.6033 3.97297 18.0003 4.63697 18.0003H7.99997V18.3413C7.99997 20.3593 9.79397 22.0003 12 22.0003C14.206 22.0003 16 20.3593 16 18.3413V18.0003H19.362C20.026 18.0003 20.619 17.6043 20.873 16.9903C21.128 16.3773 20.989 15.6773 20.521 15.2073Z'
              fill={fill || 'currentColor'}
            />
          </g>
        </svg>
      )
    }
    case 'height': {
      return (
        <svg
          width={width || '24'}
          height={width || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            id='Combined Shape'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M3 4H10C10.55 4 11 4.45 11 5C11 5.55 10.55 6 10 6H3C2.45 6 2 5.55 2 5C2 4.45 2.45 4 3 4ZM6 11H10C10.55 11 11 11.45 11 12C11 12.55 10.55 13 10 13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11ZM10 18H8C7.45 18 7 18.45 7 19C7 19.55 7.45 20 8 20H10C10.55 20 11 19.55 11 19C11 18.45 10.55 18 10 18ZM19.0002 16.6438L20.3052 15.3838C20.7032 15.0008 21.3362 15.0128 21.7192 15.4088C22.1032 15.8068 22.0922 16.4398 21.6952 16.8228L18.6952 19.7198C18.5002 19.9058 18.2502 19.9998 18.0002 19.9998C17.7442 19.9998 17.4882 19.9028 17.2932 19.7068L14.2932 16.7068C13.9022 16.3168 13.9022 15.6838 14.2932 15.2928C14.6832 14.9028 15.3162 14.9028 15.7072 15.2928L17.0002 16.5858V7.3568L15.6952 8.6158C15.2972 9.0008 14.6652 8.9878 14.2812 8.5908C13.8972 8.1938 13.9082 7.5608 14.3052 7.1768L17.3052 4.2798C17.6982 3.9048 18.3222 3.9068 18.7072 4.2928L21.7072 7.2928C22.0972 7.6838 22.0972 8.3168 21.7072 8.7068C21.5122 8.9028 21.2562 8.9998 21.0002 8.9998C20.7442 8.9998 20.4882 8.9028 20.2932 8.7068L19.0002 7.4138V16.6438Z'
            fill={fill || 'currentColor'}
          />
        </svg>
      )
    }
    case 'chevron-up': {
      return (
        <svg
          width={width || '24'}
          height={width || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          {...rest}
        >
          <path
            id='Icon'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M16 14.5C15.744 14.5 15.488 14.402 15.293 14.207L11.988 10.902L8.69502 14.082C8.29702 14.466 7.66502 14.456 7.28102 14.057C6.89702 13.66 6.90802 13.026 7.30502 12.643L11.305 8.78103C11.698 8.40203 12.322 8.40703 12.707 8.79303L16.707 12.793C17.098 13.184 17.098 13.816 16.707 14.207C16.512 14.402 16.256 14.5 16 14.5Z'
            fill={fill || 'currentColor'}
          />
        </svg>
      )
    }
    case 'options-2': {
      return (
        <svg
          width={width || '24'}
          height={width || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            id='Icon'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M3 7.00012H4.185C4.599 8.16112 5.698 9.00012 7 9.00012C8.302 9.00012 9.401 8.16112 9.815 7.00012H21C21.553 7.00012 22 6.55312 22 6.00012C22 5.44712 21.553 5.00012 21 5.00012H9.815C9.401 3.83912 8.302 3.00012 7 3.00012C5.698 3.00012 4.599 3.83912 4.185 5.00012H3C2.447 5.00012 2 5.44712 2 6.00012C2 6.55312 2.447 7.00012 3 7.00012ZM19 9.00012C17.698 9.00012 16.599 9.83912 16.185 11.0001H3C2.447 11.0001 2 11.4471 2 12.0001C2 12.5531 2.447 13.0001 3 13.0001H16.185C16.599 14.1611 17.698 15.0001 19 15.0001C20.654 15.0001 22 13.6541 22 12.0001C22 10.3461 20.654 9.00012 19 9.00012ZM13.815 17.0001H21C21.553 17.0001 22 17.4471 22 18.0001C22 18.5531 21.553 19.0001 21 19.0001H13.815C13.401 20.1611 12.302 21.0001 11 21.0001C9.698 21.0001 8.599 20.1611 8.185 19.0001H3C2.447 19.0001 2 18.5531 2 18.0001C2 17.4471 2.447 17.0001 3 17.0001H8.185C8.599 15.8391 9.698 15.0001 11 15.0001C12.302 15.0001 13.401 15.8391 13.815 17.0001Z'
            fill={fill || 'currentColor'}
          />
        </svg>
      )
    }
    case 'pie-chart': {
      return (
        <svg
          width={width || '24'}
          height={width || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          {...rest}
        >
          <path
            id='Icon'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M20.2734 8.66657C19.9074 6.11557 17.8844 4.09257 15.3334 3.72657V8.66657H20.2734ZM21.1665 10.3326H14.5004C14.0404 10.3326 13.6664 9.96057 13.6664 9.49957V2.83257C13.6664 2.37257 14.0404 1.99957 14.5004 1.99957C18.6355 1.99957 22.0005 5.36457 22.0005 9.49957C22.0005 9.96057 21.6264 10.3326 21.1665 10.3326ZM12.9344 11.9776H21.0834C21.6254 11.9776 22.0494 12.4496 21.9954 12.9886C21.4514 18.4146 16.5794 22.5666 10.8814 21.9366C6.29645 21.4306 2.56945 17.7036 2.06245 13.1186C1.43445 7.42057 5.58445 2.54757 11.0114 2.00457C11.5514 1.95057 12.0224 2.37357 12.0224 2.91557V11.0666C12.0224 11.5696 12.4304 11.9776 12.9344 11.9776Z'
            fill={fill || 'currentColor'}
          />
        </svg>
      )
    }
    case 'bar-chart': {
      return (
        <svg
          width={width || '24'}
          height={width || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            id='Icon'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M12 4C11.45 4 11 4.45 11 5V20C11 20.55 11.45 21 12 21C12.55 21 13 20.55 13 20V5C13 4.45 12.55 4 12 4ZM19 12C18.45 12 18 12.45 18 13V20C18 20.55 18.45 21 19 21C19.55 21 20 20.55 20 20V13C20 12.45 19.55 12 19 12ZM4 9C4 8.45 4.45 8 5 8C5.55 8 6 8.45 6 9V20C6 20.55 5.55 21 5 21C4.45 21 4 20.55 4 20V9Z'
            fill={fill || 'currentColor'}
          />
        </svg>
      )
    }
    case 'list': {
      return (
        <svg
          width={width || '24'}
          height={width || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            id='Icon'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M3 7C3 6.448 3.448 6 4 6C4.552 6 5 6.448 5 7C5 7.552 4.552 8 4 8C3.448 8 3 7.552 3 7ZM3 12C3 11.448 3.448 11 4 11C4.552 11 5 11.448 5 12C5 12.552 4.552 13 4 13C3.448 13 3 12.552 3 12ZM4 16C3.448 16 3 16.448 3 17C3 17.552 3.448 18 4 18C4.552 18 5 17.552 5 17C5 16.448 4.552 16 4 16ZM7.9355 11H20.0645C20.5795 11 21.0005 11.421 21.0005 11.936V12.064C21.0005 12.579 20.5795 13 20.0645 13H7.9355C7.4205 13 7.0005 12.579 7.0005 12.064V11.936C7.0005 11.421 7.4205 11 7.9355 11ZM20.0645 16H7.9355C7.4205 16 7.0005 16.421 7.0005 16.936V17.064C7.0005 17.579 7.4205 18 7.9355 18H20.0645C20.5795 18 21.0005 17.579 21.0005 17.064V16.936C21.0005 16.421 20.5795 16 20.0645 16ZM7.9355 6H20.0645C20.5795 6 21.0005 6.421 21.0005 6.936V7.064C21.0005 7.579 20.5795 8 20.0645 8H7.9355C7.4205 8 7.0005 7.579 7.0005 7.064V6.936C7.0005 6.421 7.4205 6 7.9355 6Z'
            fill={fill || 'currentColor'}
          />
        </svg>
      )
    }
    case 'layers': {
      return (
        <svg
          width={width || '24'}
          height={width || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          {...rest}
        >
          <path
            id='Icon'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M3.2407 7.28712L11.7617 11.9231C11.9087 12.0031 12.0907 12.0031 12.2387 11.9231L20.7597 7.28712C21.1027 7.10012 21.0727 6.62212 20.7077 6.47512L12.1877 3.03612C12.0677 2.98812 11.9317 2.98812 11.8117 3.03612L3.2917 6.47512C2.9277 6.62212 2.8977 7.10012 3.2407 7.28712ZM20.708 10.6563L18.878 9.87632L12.239 13.4883C12.091 13.5683 11.909 13.5683 11.761 13.4883L5.122 9.87632L3.292 10.6563C2.927 10.8113 2.897 11.3173 3.241 11.5143L11.761 16.4113C11.909 16.4963 12.091 16.4963 12.239 16.4113L20.759 11.5143C21.103 11.3173 21.073 10.8113 20.708 10.6563ZM19.151 14.4227L20.708 15.0967C21.073 15.2547 21.103 15.7677 20.759 15.9677L12.239 20.9357C12.091 21.0217 11.909 21.0217 11.761 20.9357L3.241 15.9677C2.897 15.7677 2.927 15.2547 3.292 15.0967L4.849 14.4227L11.761 18.1837C11.909 18.2637 12.091 18.2637 12.239 18.1837L19.151 14.4227Z'
            fill={fill || 'currentColor'}
          />
        </svg>
      )
    }
    case 'flash': {
      return (
        <svg
          width={width || '24'}
          height={width || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            id='Icon'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M11.1114 23.0001C10.9974 23.0001 10.8824 22.9801 10.7694 22.9391C10.3374 22.7821 10.0674 22.3501 10.1174 21.8931L10.8854 14.8001H5.00036C4.63136 14.8001 4.29236 14.5971 4.11836 14.2711C3.94436 13.9451 3.96436 13.5511 4.16936 13.2441L12.0574 1.44409C12.3134 1.06109 12.7974 0.90209 13.2304 1.06109C13.6634 1.21809 13.9324 1.65009 13.8824 2.10709L13.1144 9.20009H19.0004C19.3694 9.20009 19.7084 9.40309 19.8824 9.72909C20.0554 10.0551 20.0364 10.4491 19.8314 10.7561L11.9424 22.5561C11.7534 22.8401 11.4374 23.0001 11.1114 23.0001Z'
            fill={fill || 'currentColor'}
          />
        </svg>
      )
    }
    case 'checkmark-circle': {
      return (
        <svg
          width={width || '24'}
          height={width || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            id='Icon'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M16.2954 9.60549L11.7274 15.6055C11.5394 15.8525 11.2484 15.9985 10.9384 16.0005H10.9314C10.6244 16.0005 10.3344 15.8585 10.1444 15.6165L7.71237 12.5095C7.37237 12.0755 7.44837 11.4465 7.88337 11.1065C8.31737 10.7655 8.94737 10.8415 9.28737 11.2775L10.9204 13.3635L14.7044 8.39449C15.0384 7.95549 15.6654 7.86949 16.1064 8.20449C16.5454 8.53949 16.6304 9.16649 16.2954 9.60549ZM12.0004 2.00049C6.47737 2.00049 2.00037 6.47749 2.00037 12.0005C2.00037 17.5225 6.47737 22.0005 12.0004 22.0005C17.5234 22.0005 22.0004 17.5225 22.0004 12.0005C22.0004 6.47749 17.5234 2.00049 12.0004 2.00049Z'
            fill={fill || 'currentColor'}
          />
        </svg>
      )
    }
    case 'minus-circle': {
      return (
        <svg
          width={width || '24'}
          height={width || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            id='Icon'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M15 13H9C8.45 13 8 12.55 8 12C8 11.45 8.45 11 9 11H15C15.55 11 16 11.45 16 12C16 12.55 15.55 13 15 13ZM12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2Z'
            fill={fill || 'currentColor'}
          />
        </svg>
      )
    }
    case 'open-external-link': {
      return (
        <svg
          width={width || '24'}
          height={width || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g>
            <path
              id='Icon'
              fillRule='evenodd'
              clipRule='evenodd'
              d='M 21.628906 14.175781 C 21.628906 13.554688 22.132812 13.046875 22.757812 13.046875 C 23.382812 13.046875 23.886719 13.554688 23.886719 14.175781 L 23.886719 20.660156 C 23.886719 21.578125 23.511719 22.414062 22.90625 23.019531 C 22.300781 23.625 21.464844 24 20.546875 24 L 3.371094 24 C 2.449219 24 1.613281 23.625 1.007812 23.019531 C 0.402344 22.414062 0.0273438 21.578125 0.0273438 20.660156 L 0.0273438 3.359375 C 0.0273438 2.4375 0.402344 1.601562 1.007812 0.996094 C 1.613281 0.390625 2.449219 0.015625 3.371094 0.015625 L 9.8125 0.015625 C 10.433594 0.015625 10.9375 0.523438 10.9375 1.144531 C 10.9375 1.769531 10.433594 2.273438 9.8125 2.273438 L 3.371094 2.273438 C 3.074219 2.273438 2.804688 2.398438 2.605469 2.59375 C 2.410156 2.789062 2.289062 3.058594 2.289062 3.355469 L 2.289062 20.65625 C 2.289062 20.953125 2.410156 21.222656 2.605469 21.417969 C 2.804688 21.617188 3.074219 21.738281 3.371094 21.738281 L 20.546875 21.738281 C 20.84375 21.738281 21.113281 21.613281 21.3125 21.417969 C 21.507812 21.222656 21.628906 20.953125 21.628906 20.65625 Z M 21.984375 3.410156 L 10.578125 14.960938 C 10.140625 15.402344 9.425781 15.410156 8.980469 14.972656 C 8.539062 14.539062 8.53125 13.824219 8.96875 13.378906 L 19.9375 2.273438 L 15.371094 2.273438 C 14.75 2.273438 14.242188 1.765625 14.242188 1.144531 C 14.242188 0.519531 14.75 0.015625 15.371094 0.015625 L 20.546875 0.015625 C 21.546875 0.015625 22.835938 -0.15625 23.601562 0.621094 C 24.089844 1.109375 23.980469 5.019531 23.917969 7.28125 C 23.902344 7.867188 23.890625 8.316406 23.890625 8.636719 C 23.890625 9.257812 23.382812 9.765625 22.757812 9.765625 C 22.136719 9.765625 21.632812 9.257812 21.632812 8.636719 C 21.632812 8.574219 21.648438 7.988281 21.667969 7.222656 C 21.699219 6.042969 21.890625 4.480469 21.984375 3.410156 Z M 21.984375 3.410156 '
              fill={fill || 'currentColor'}
            />
          </g>
        </svg>
      )
    }
    case 'arrow-right': {
      return (
        <svg
          width={width || '24'}
          height={width || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            id='Icon'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M5 13H16.865L13.232 17.36C12.878 17.784 12.936 18.415 13.36 18.768C13.785 19.122 14.415 19.064 14.769 18.64L19.769 12.64C19.808 12.593 19.827 12.538 19.856 12.486C19.88 12.444 19.909 12.408 19.927 12.362C19.972 12.247 19.999 12.126 19.999 12.004C19.999 12.003 20 12.001 20 12C20 11.999 19.999 11.997 19.999 11.996C19.999 11.874 19.972 11.753 19.927 11.638C19.909 11.592 19.88 11.556 19.856 11.514C19.827 11.462 19.808 11.407 19.769 11.36L14.769 5.36C14.57 5.123 14.286 5 14 5C13.774 5 13.547 5.076 13.36 5.232C12.936 5.585 12.878 6.216 13.232 6.64L16.865 11H5C4.448 11 4 11.448 4 12C4 12.552 4.448 13 5 13Z'
            fill={fill || 'currentColor'}
          />
        </svg>
      )
    }
    case 'award': {
      return (
        <svg
          width={width || '24'}
          height={width || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            id='Icon'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M12 3.99988C14.206 3.99988 16 5.79388 16 7.99988C16 10.2059 14.206 11.9999 12 11.9999C9.79395 11.9999 7.99995 10.2059 7.99995 7.99988C7.99995 5.79388 9.79395 3.99988 12 3.99988ZM18.969 20.7509L16.66 11.7719C17.496 10.7399 18 9.42888 18 7.99988C18 4.69088 15.309 1.99988 12 1.99988C8.69096 1.99988 5.99996 4.69088 5.99996 7.99988C5.99996 9.42888 6.50396 10.7399 7.33996 11.7719L5.03096 20.7509C4.93096 21.1429 5.07496 21.5559 5.39796 21.7989C5.72096 22.0419 6.15796 22.0639 6.50596 21.8619L11.836 18.7329L17.516 21.8749C17.667 21.9589 17.834 21.9999 18 21.9999C18.217 21.9999 18.433 21.9299 18.612 21.7909C18.928 21.5469 19.068 21.1379 18.969 20.7509Z'
            fill={fill || 'currentColor'}
          />
        </svg>
      )
    }
    case 'rocket': {
      return (
        <svg
          width={width || '24'}
          height={width || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            id='Vector'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M18.165 2.765L18.42 2.797C19.094 2.89 19.986 3.015 20.491 3.521C20.905 3.934 21.064 4.606 21.159 5.206L21.215 5.592C21.341 6.502 21.374 7.694 21.159 9.018C20.735 11.631 19.344 14.749 15.851 17.163C15.832 17.351 15.831 17.541 15.835 17.731L15.845 18.015C15.861 18.452 15.877 18.888 15.755 19.313C15.565 19.973 14.888 20.408 14.255 20.72L13.945 20.867L13.545 21.043C12.797 21.361 11.787 21.687 11.154 21.053C10.774 20.674 10.618 20.118 10.491 19.565L10.444 19.358C10.3911 19.0967 10.3243 18.8383 10.244 18.584C10.194 18.438 10.14 18.289 10.082 18.139C10.0182 18.2174 9.95046 18.2925 9.87905 18.364C9.53405 18.709 9.01905 18.95 8.59505 19.119C8.13205 19.302 7.60805 19.462 7.12305 19.594L6.87405 19.66L6.39705 19.779L5.96505 19.879L5.44805 19.989L5.12505 20.052C4.96396 20.0818 4.79803 20.072 4.64157 20.0234C4.48512 19.9748 4.34283 19.8889 4.22699 19.7731C4.11115 19.6572 4.02522 19.5149 3.97663 19.3585C3.92803 19.202 3.91822 19.0361 3.94805 18.875L4.03405 18.444L4.18805 17.746L4.31205 17.236L4.40605 16.876C4.53805 16.392 4.69805 15.868 4.88205 15.406C5.05005 14.981 5.29105 14.466 5.63605 14.121L5.71605 14.044L5.65205 14.018C5.48115 13.953 5.30804 13.894 5.13305 13.841L4.85605 13.756C4.16205 13.546 3.42005 13.32 2.95905 12.858C2.39905 12.299 2.58805 11.448 2.85805 10.74L2.96805 10.466L3.14505 10.066L3.29205 9.756C3.60405 9.124 4.03905 8.447 4.69905 8.257C5.04905 8.157 5.41305 8.151 5.77905 8.161L5.99905 8.168C6.28505 8.178 6.57005 8.189 6.84905 8.162C9.26305 4.668 12.381 3.277 14.994 2.853C16.0423 2.68108 17.1089 2.65148 18.165 2.765ZM8.35305 15.44C8.19566 15.3235 8.00756 15.2557 7.81204 15.2451C7.61653 15.2344 7.42217 15.2813 7.25305 15.38L7.14305 15.454L7.05005 15.537L6.92505 15.695C6.66505 16.071 6.51705 16.591 6.40205 17.077L6.29405 17.545L6.24305 17.758L6.43405 17.712L6.85205 17.616C7.43005 17.481 8.07105 17.306 8.46505 16.951C8.63636 16.7798 8.7397 16.5522 8.75589 16.3105C8.77207 16.0689 8.7 15.8295 8.55305 15.637L8.47105 15.543L8.44705 15.52L8.35305 15.44ZM15.536 8.466C15.3504 8.28025 15.1299 8.13289 14.8873 8.03233C14.6446 7.93178 14.3846 7.88 14.1219 7.87995C13.8593 7.87991 13.5992 7.93159 13.3565 8.03206C13.1138 8.13253 12.8933 8.27981 12.7075 8.4655C12.5218 8.65119 12.3744 8.87165 12.2739 9.11429C12.1733 9.35693 12.1215 9.617 12.1215 9.87965C12.1214 10.1423 12.1731 10.4024 12.2736 10.6451C12.3741 10.8877 12.5214 11.1082 12.707 11.294C13.0821 11.6692 13.5907 11.88 14.1212 11.8801C14.6516 11.8801 15.1604 11.6695 15.5355 11.2945C15.9107 10.9195 16.1215 10.4108 16.1216 9.88036C16.1217 9.34991 15.9111 8.84115 15.536 8.466Z'
            fill={fill || 'currentColor'}
          />
        </svg>
      )
    }
    case 'flask': {
      return (
        <svg width={width || '24'} height={width || '24'} viewBox='0 0 512 512'>
          <path
            fill={fill || 'currentColor'}
            d='M452.32,365,327.4,167.12A48.07,48.07,0,0,1,320,141.48V64h15.56c8.61,0,16-6.62,16.43-15.23A16,16,0,0,0,336,32H176.45c-8.61,0-16,6.62-16.43,15.23A16,16,0,0,0,176,64h16v77.48a47.92,47.92,0,0,1-7.41,25.63L59.68,365a74,74,0,0,0-2.5,75.84C70.44,465.19,96.36,480,124.13,480H387.87c27.77,0,53.69-14.81,66.95-39.21A74,74,0,0,0,452.32,365ZM211.66,184.2A79.94,79.94,0,0,0,224,141.48V68a4,4,0,0,1,4-4h56a4,4,0,0,1,4,4v73.48a79.94,79.94,0,0,0,12.35,42.72l57.8,91.53A8,8,0,0,1,351.37,288H160.63a8,8,0,0,1-6.77-12.27Z'
          ></path>
        </svg>
      )
    }
    case 'features': {
      return (
        <svg
          width={width || '24'}
          height={width || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g id='Filled/toggle-right'>
            <path
              id='Icon'
              fillRule='evenodd'
              clipRule='evenodd'
              d='M15.4647 16C13.2591 16.0027 11.462 14.2109 11.4594 12.0053C11.4567 9.7984 13.2484 8.00267 15.454 8C17.661 7.99733 19.4567 9.78905 19.4593 11.9947C19.462 14.2003 17.6703 15.9973 15.4647 16M15.156 5.00001L8.73199 5.00801C4.6019 5.01301 1.24358 8.15436 1.25001 12.011C1.25537 15.8657 4.62119 19 8.75343 18.994L15.1764 18.986C19.3075 18.981 22.6648 15.8396 22.6594 11.983C22.6541 8.12835 19.2872 4.99401 15.156 5.00001Z'
              fill={fill || 'currentColor'}
            />
          </g>
        </svg>
      )
    }
    case 'timer': {
      return (
        <svg
          width={width || '24'}
          height={width || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            id='Icon'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M15 14H12C11.448 14 11 13.553 11 13V10C11 9.447 11.448 9 12 9C12.552 9 13 9.447 13 10V12H15C15.552 12 16 12.447 16 13C16 13.553 15.552 14 15 14ZM12.988 4.058C12.99 4.037 13 4.021 13 4V3H14C14.552 3 15 2.553 15 2C15 1.447 14.552 1 14 1H10C9.448 1 9 1.447 9 2C9 2.553 9.448 3 10 3H11V4C11 4.021 11.01 4.037 11.012 4.058C6.513 4.552 3 8.372 3 13C3 17.963 7.038 22 12 22C16.962 22 21 17.963 21 13C21 8.372 17.487 4.552 12.988 4.058Z'
            fill={fill || 'currentColor'}
          />
        </svg>
      )
    }
    case 'request': {
      return (
        <svg
          width={width || '24'}
          height={width || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            id='Vector'
            d='M12.793 3.172C12.9729 2.99266 13.2144 2.88853 13.4684 2.88078C13.7223 2.87302 13.9697 2.96222 14.1603 3.13025C14.3508 3.29829 14.4703 3.53256 14.4944 3.78548C14.5185 4.0384 14.4454 4.29101 14.29 4.492L14.207 4.586L13.793 5H16C16.7652 4.99996 17.5015 5.29233 18.0582 5.81729C18.615 6.34225 18.9501 7.06011 18.995 7.824L19 8V15.17C19.6671 15.4062 20.2294 15.8705 20.5873 16.481C20.9453 17.0915 21.076 17.8088 20.9564 18.5063C20.8368 19.2039 20.4745 19.8367 19.9335 20.293C19.3925 20.7493 18.7077 20.9997 18 21C17.308 21.0002 16.6372 20.7612 16.1012 20.3234C15.5653 19.8857 15.1972 19.2761 15.0592 18.598C14.9213 17.9198 15.022 17.2149 15.3444 16.6025C15.6667 15.9902 16.1909 15.5081 16.828 15.238L17 15.17V8C16.9999 7.75507 16.91 7.51867 16.7473 7.33563C16.5845 7.1526 16.3602 7.03566 16.117 7.007L16 7H13.793L14.207 7.414C14.3882 7.59355 14.494 7.83557 14.5027 8.09055C14.5113 8.34553 14.4222 8.59417 14.2535 8.78558C14.0848 8.977 13.8494 9.09671 13.5954 9.12021C13.3413 9.14371 13.0879 9.06923 12.887 8.912L12.793 8.828L10.672 6.708C10.4994 6.53588 10.3956 6.30665 10.3801 6.06339C10.3647 5.82013 10.4386 5.5796 10.588 5.387L10.672 5.293L12.792 3.172H12.793ZM5.99998 3C6.69199 2.99979 7.36279 3.23881 7.89873 3.67657C8.43468 4.11434 8.8028 4.72392 8.94073 5.40204C9.07866 6.08017 8.97792 6.78512 8.65557 7.39746C8.33322 8.00981 7.80909 8.49188 7.17198 8.762L6.99998 8.83V15.172C7.66572 15.4091 8.22641 15.8736 8.58328 16.4836C8.94014 17.0936 9.07028 17.81 8.95077 18.5065C8.83125 19.2031 8.46975 19.8351 7.92995 20.2912C7.39015 20.7474 6.70669 20.9984 5.99998 21C5.30797 21.0002 4.63717 20.7612 4.10122 20.3234C3.56528 19.8857 3.19716 19.2761 3.05922 18.598C2.92129 17.9198 3.02204 17.2149 3.34439 16.6025C3.66674 15.9902 4.19087 15.5081 4.82798 15.238L4.99998 15.17V8.829C4.33354 8.59236 3.77208 8.12795 3.41465 7.51771C3.05723 6.90747 2.9268 6.1906 3.04638 5.49357C3.16596 4.79655 3.52786 4.16414 4.06825 3.70793C4.60863 3.25171 5.29277 3.00099 5.99998 3Z'
            fill={fill || 'currentColor'}
          />
        </svg>
      )
    }
    case 'people': {
      return (
        <svg
          width={width || '24'}
          height={width || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g id='Filled/people'>
            <path
              id='Icon'
              fillRule='evenodd'
              clipRule='evenodd'
              d='M9 11C11.206 11 13 9.206 13 7C13 4.794 11.206 3 9 3C6.794 3 5 4.794 5 7C5 9.206 6.794 11 9 11ZM17 13C18.654 13 20 11.654 20 10C20 8.346 18.654 7 17 7C15.346 7 14 8.346 14 10C14 11.654 15.346 13 17 13ZM22 19C22 19.552 21.553 20 21 20H16C16 20.552 15.553 21 15 21H3C2.447 21 2 20.552 2 20C2 16.14 5.141 13 9 13C10.927 13 12.673 13.783 13.94 15.046C14.809 14.374 15.879 14 17 14C19.757 14 22 16.243 22 19Z'
              fill={fill || 'currentColor'}
            />
          </g>
        </svg>
      )
    }
    case 'more-vertical': {
      return (
        <svg
          width={width || '24'}
          height={width || '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            id='Filled/more-vertical'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M12 7C13.104 7 14 6.104 14 5C14 3.896 13.104 3 12 3C10.896 3 10 3.896 10 5C10 6.104 10.896 7 12 7ZM12 10C10.896 10 10 10.896 10 12C10 13.104 10.896 14 12 14C13.104 14 14 13.104 14 12C14 10.896 13.104 10 12 10ZM10 19C10 17.896 10.896 17 12 17C13.104 17 14 17.896 14 19C14 20.104 13.104 21 12 21C10.896 21 10 20.104 10 19Z'
            fill={fill || 'currentColor'}
          />
        </svg>
      )
    }
    case 'pr-merged': {
      return (
        <svg
          version='1.1'
          width={width || '16'}
          height={height || '16'}
          fill='#8957e5'
          className='ml-1'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path d='M5.45 5.154A4.25 4.25 0 0 0 9.25 7.5h1.378a2.251 2.251 0 1 1 0 1.5H9.25A5.734 5.734 0 0 1 5 7.123v3.505a2.25 2.25 0 1 1-1.5 0V5.372a2.25 2.25 0 1 1 1.95-.218ZM4.25 13.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm8.5-4.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM5 3.25a.75.75 0 1 0 0 .005V3.25Z'></path>
        </svg>
      )
    }
    case 'issue-closed': {
      return (
        <svg
          version='1.1'
          width={width || '16'}
          height={height || '16'}
          fill='#8957e5'
          className='ml-1'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path d='M11.28 6.78a.75.75 0 0 0-1.06-1.06L7.25 8.69 5.78 7.22a.75.75 0 0 0-1.06 1.06l2 2a.75.75 0 0 0 1.06 0l3.5-3.5Z'></path>
          <path d='M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-1.5 0a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0Z'></path>
        </svg>
      )
    }
    case 'issue-linked': {
      return (
        <svg
          width={width || '16'}
          height={height || '16'}
          xmlns='http://www.w3.org/2000/svg'
          fill='#238636'
          className='ml-1'
        >
          <path d='M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z'></path>
          <path d='M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM1.5 8a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0Z'></path>
        </svg>
      )
    }
    case 'pr-linked': {
      return (
        <svg
          version='1.1'
          height={height || '16'}
          width={width || '16'}
          fill='#238636'
          className='ml-1'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path d='M1.5 3.25a2.25 2.25 0 1 1 3 2.122v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.25 2.25 0 0 1 1.5 3.25Zm5.677-.177L9.573.677A.25.25 0 0 1 10 .854V2.5h1A2.5 2.5 0 0 1 13.5 5v5.628a2.251 2.251 0 1 1-1.5 0V5a1 1 0 0 0-1-1h-1v1.646a.25.25 0 0 1-.427.177L7.177 3.427a.25.25 0 0 1 0-.354ZM3.75 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm0 9.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm8.25.75a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0Z'></path>
        </svg>
      )
    }
    case 'pr-closed': {
      return (
        <svg
          version='1.1'
          width={width || '16'}
          height={height || '16'}
          fill='#da3633'
          className='ml-1'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path d='M3.25 1A2.25 2.25 0 0 1 4 5.372v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.251 2.251 0 0 1 3.25 1Zm9.5 5.5a.75.75 0 0 1 .75.75v3.378a2.251 2.251 0 1 1-1.5 0V7.25a.75.75 0 0 1 .75-.75Zm-2.03-5.273a.75.75 0 0 1 1.06 0l.97.97.97-.97a.748.748 0 0 1 1.265.332.75.75 0 0 1-.205.729l-.97.97.97.97a.751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018l-.97-.97-.97.97a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734l.97-.97-.97-.97a.75.75 0 0 1 0-1.06ZM2.5 3.25a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0ZM3.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm9.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z'></path>
        </svg>
      )
    }
    case 'pr-draft': {
      return (
        <svg
          height={height || '16'}
          version='1.1'
          width={width || '16'}
          fill={fill || 'currentColor'}
          className='ml-1'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path d='M1.5 3.25a2.25 2.25 0 1 1 3 2.122v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.25 2.25 0 0 1 1.5 3.25Zm5.677-.177L9.573.677A.25.25 0 0 1 10 .854V2.5h1A2.5 2.5 0 0 1 13.5 5v5.628a2.251 2.251 0 1 1-1.5 0V5a1 1 0 0 0-1-1h-1v1.646a.25.25 0 0 1-.427.177L7.177 3.427a.25.25 0 0 1 0-.354ZM3.75 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm0 9.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm8.25.75a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0Z'></path>
        </svg>
      )
    }
    case 'expand': {
      return (
        <svg
          viewBox='0 0 24 24'
          height={height ?? '24'}
          width={width ?? '24'}
          fill={fill ?? 'currentColor'}
          xmlns='http://www.w3.org/2000/svg'
        >
          <g id='Outlined/expand'>
            <path
              id='Icon'
              fillRule='evenodd'
              clipRule='evenodd'
              d='M19.0016 4.02543C19.5516 4.02843 19.9966 4.47443 19.9966 5.02443L19.9996 9.99943C20.0006 10.5514 19.5526 11.0004 19.0006 11.0004H18.9996C18.4476 11.0004 18.0006 10.5524 17.9996 10.0014L17.9976 7.41643L14.7066 10.7074C14.5116 10.9024 14.2556 11.0004 13.9996 11.0004C13.7446 11.0004 13.4886 10.9024 13.2926 10.7074C12.9026 10.3164 12.9026 9.68343 13.2926 9.29343L16.5726 6.01343L13.9956 6.00043C13.4426 5.99743 12.9966 5.54643 12.9996 4.99543C13.0026 4.44443 13.4506 4.00043 13.9996 4.00043H14.0046L19.0016 4.02543ZM9.29302 13.293C9.68401 12.902 10.316 12.902 10.707 13.293C11.098 13.684 11.098 14.316 10.707 14.707L7.41501 17.999L10 18C10.553 18 11 18.448 11 19.001C10.999 19.553 10.552 20 10 20H9.99901L5.02402 19.997C4.47402 19.997 4.02802 19.552 4.02502 19.002L4.00002 14.005C3.99702 13.453 4.44302 13.003 4.99502 13H5.00002C5.55001 13 5.99701 13.444 6.00002 13.995L6.01302 16.573L9.29302 13.293Z'
            />
          </g>
        </svg>
      )
    }

    case 'radio': {
      return (
        <svg
          viewBox='0 0 24 24'
          height={height ?? '24'}
          width={width ?? '24'}
          fill={fill ?? 'currentColor'}
          xmlns='http://www.w3.org/2000/svg'
        >
          <g id='Outlined/circle'>
            <path
              id='Icon'
              fillRule='evenodd'
              clipRule='evenodd'
              d='M12 4C7.589 4 4 7.589 4 12C4 16.411 7.589 20 12 20C16.411 20 20 16.411 20 12C20 7.589 16.411 4 12 4ZM12 22C6.486 22 2 17.514 2 12C2 6.486 6.486 2 12 2C17.514 2 22 6.486 22 12C22 17.514 17.514 22 12 22Z'
            />
          </g>
        </svg>
      )
    }

    default:
      return null
  }
}

export default Icon
